import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { ApiClientService } from '../http';
import { BusinessSettingsStore } from './business-settings.store';
import { AuthStore } from '../auth';

const initializeBusinessSettings = async () => {
  const authStore = inject(AuthStore);
  const businessSettingsStore = inject(BusinessSettingsStore);
  
  if (!authStore.isAuthenticated()) {
    return;
  }

  const api = inject(ApiClientService);

  try {
    const response = await firstValueFrom(api.get<{ data: { currencyCode: string; timeZone: string } }>('/business-settings'));
    businessSettingsStore.loadFromApi(response.data);
  } catch {
    businessSettingsStore.loadFromApi({ currencyCode: 'EUR', timeZone: 'Europe/Madrid' });
  }
};

export const provideBusinessSettingsBootstrap = (): EnvironmentProviders => provideAppInitializer(initializeBusinessSettings);